import React, { useState, useEffect, useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Divider,
  Grid,
  Typography,
  Accordion,
  Fab,
  AccordionSummary,
  AccordionDetails,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Slide,
} from "@material-ui/core";


import InfoIcon from '@material-ui/icons/Info';
import CheckIcon from '@material-ui/icons/Check';
import { PageContext } from "../../contexts/PageContext";
import InfoTooltip from "../general/InfoTooltip";
import CreditField from "../credits/CreditField";
import { keyToLabel, getMetafieldValue } from "../../functions/GlobalHelpers"

const useStyles = makeStyles((theme) => ({
  fabIcon: {
    marginRight: theme.spacing(1),
  },
  fab: {
    position: "fixed",
    right: 20,
    bottom: 20,
    zIndex: 10
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PortalFields(
  {
    portal,
    setFieldsPercentProgress,
    savePortal
  }) {
  const theme = useTheme();
  const classes = useStyles();
  const [fields, setFields] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const pageContext = useContext(PageContext);
  const index = portal.person_index;

  useEffect(() => {
    if (portal && portal.fields_settings) {
      setFields(portal.fields_settings);
    } else {
      setFields([])
    }
  }, [portal]);

  const getPercentProgress = () => {
    const visibleFields = fields.filter(field => isFieldVisible(field));
    return Math.round(
      visibleFields.filter(field => (
        (
          ["STRING_ENUM", "STRING", "DATE"].includes(field.field_type) && field.meta_value
        ) ||
        (
          ["INT_ENUM", "INT"].includes(field.field_type) && (field.meta_value_numeric || field.meta_value_numeric === 0)
        ) ||
        (
          ["BOOLEAN"].includes(field.field_type) // booleans are always "finished"
        )
      )).length / visibleFields.length * 100
    );
  }

  useEffect(() => {
    setFieldsPercentProgress(
      getPercentProgress()
    )
  }, [fields]);

  const savePortalFields = (done = false) => {
    savePortal({
      id: portal.id,
      status: (done ? "fields_done" : portal.status),
      fields_settings: fields
    }, () => {
      if (done)
        pageContext.setInfoMessage("Vielen Dank! Ihre Eingaben wurden an Ihren Berater gesendet.")
      else {
        pageContext.setInfoMessage("Ihre Eingaben wurden gespeichert. Füllen Sie bitte noch den Rest aus um die Eingaben an den Berater zu übermitteln.");
      }
    });
  }
  const resolvePlaceholders = (text) => {
    return text
    // if (!text)
    // 	return "";
    // return text.replace(/(\[.+?\])/g, (match, contents, offset, input_string) => {
    // 	const replacement = getFirstValueByMetaKey(match.substring(1, match.length - 1));
    // 	if (replacement)
    // 		return replacement;
    // 	return "";
    // });
  }


  const isFieldVisible = (currentField) => {

    if (!currentField.config.conditions || currentField.config.conditions.length === 0)
      return true;



    let is_visible = true;
    currentField.config.conditions.forEach(condition => {
      if (condition.meta_key) {
        let condition_metafield = fields.find(field => field.meta_key === condition.meta_key);
        if (condition_metafield) {
          const value = getMetafieldValue(condition_metafield);
          if (condition.condition === "==" && value !== condition.meta_value)
            is_visible = false;
          if (condition.condition === "!=" && value === condition.meta_value)
            is_visible = false;
          if (condition.condition === ">" && (value === undefined || value === null || value <= condition.meta_value))
            is_visible = false;
          if ((condition.condition === ">=" || condition.condition === "=>") && (value === undefined || value === null || value < condition.meta_value))
            is_visible = false;
          if (condition.condition === "<" && value >= condition.meta_value)
            is_visible = false;
          if ((condition.condition === "<=" || condition.condition === "=<") && value > condition.meta_value)
            is_visible = false;
          if (condition.condition === "notempty" && !value)
            is_visible = false;
          if (condition.condition === "empty" && value)
            is_visible = false;
        }
      }
    })

    return is_visible;
  }

  const renderCreditField = (meta_key, xs = 12, md = 12, fieldlayout = "") => {

    const field = fields.find(field => field.meta_key === meta_key);
    if (!field)
      return <></>;
    if (!isFieldVisible(field))
      return <></>;
    const metafields = [field];
    const fieldConfigs = [field.config]
    if (!fieldConfigs[0].hasOwnProperty("label"))
      fieldConfigs[0].label = keyToLabel(fieldConfigs[0].meta_key);
    return <CreditField
      setMetafieldsValues={(currentMetafields, value, forceRerender = false) => {
        const metafield = currentMetafields[0];
        setFields(fields => {
          let value_key = "meta_value";
          if (["INT_ENUM", "INT"].includes(metafield.field_type)) {
            value_key = "meta_value_numeric";
            value = parseInt(value);
            if (!value)
              value = 0;
          } else if (["BOOLEAN"].includes(metafield.field_type)) {
            value_key = "meta_value_boolean";
            if (!value)
              value = false;
          } else {
            if (!value)
              value = "";
          }
          const field_index = fields.findIndex(field => field['meta_key'] === metafield['meta_key'])
          if (field_index > -1)
            fields[field_index][value_key] = value;

          if (forceRerender)
            return [...fields];
          else
            return fields;
        })
        if (!hasChanges)
          setHasChanges(true);
      }}
      resolvePlaceholders={resolvePlaceholders}
      channelDisplayNames={[]}
      metafieldsForCurrentMetaKey={metafields}
      fieldConfigs={fieldConfigs}
      meta_key={meta_key}
      xs={xs}
      md={md}
      fieldlayout={fieldlayout}
      credit={{}}
      view="portal"
    />
  }

  if (!portal || !fields)
    return <></>
  return (
    <>
      {renderCreditField("__person" + index + "__anrede", 4, 2)}
      {renderCreditField("__person" + index + "__vorname", 8, 4)}
      {renderCreditField("__person" + index + "__nachname", 8, 4)}
      {renderCreditField("__person" + index + "__titel", 4, 2)}
      {renderCreditField("__person" + index + "__kontakt_mobil", 6, 3)}
      {renderCreditField("__person" + index + "__kontakt_telefon", 6, 3)}
      {renderCreditField("__person" + index + "__kontakt_email", 12, 3)}
      {renderCreditField("__person" + index + "__geburtsdatum", 6, 3)}
      {renderCreditField("__person" + index + "__geburtsort", 6, 4)}
      {renderCreditField("__person" + index + "__geburtsland", 6, 4)}
      {renderCreditField("__person" + index + "__nationalitaet", 6, 4)}
      {renderCreditField("__person" + index + "__familienstand", 6, 3)}
      {renderCreditField("__person" + index + "__gueterstand", 6, 3)}
      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__postleitzahl", 4, 2)}
      {renderCreditField("__person" + index + "__ort", 8, 4)}
      {renderCreditField("__person" + index + "__strasse", 8, 4)}
      {renderCreditField("__person" + index + "__hausnummer", 4, 2)}

      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__pkw_besitz", 12, 6)}
      {renderCreditField("__person" + index + "__insolvenzverfahren_letzte_5j", 12, 6)}
      {renderCreditField("__person" + index + "__inkassozahlungen_oder_mahnungen_letzte_6m", 12, 6)}
      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__bankverbindung", 12, 12)}
      {renderCreditField("__person" + index + "__bankverbindung_sonstiges", 12, 6)}


      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__aktueller_wohnstatus", 6, 4)}
      {renderCreditField("__person" + index + "__wohnhaft_seit", 6, 4)}
      {renderCreditField("__person" + index + "__zukuenftiger_wohnstatus", 12, 4)}
      {renderCreditField("__person" + index + "__anzahl_personen_im_haushalt", 12, 4)}
      {renderCreditField("__person" + index + "__anzahl_unterhaltsberechtigte_kinder", 12, 4)}
      {renderCreditField("__person" + index + "__anzahl_unterhaltsberechtigte_personen", 12, 4)}
      {renderCreditField("__person" + index + "__alter_kind1", 6, 3)}
      {renderCreditField("__person" + index + "__alter_kind2", 6, 3)}
      {renderCreditField("__person" + index + "__alter_kind3", 6, 3)}
      {renderCreditField("__person" + index + "__alter_kind4", 6, 3)}
      {renderCreditField("__person" + index + "__alter_kind5", 6, 3)}

      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__beruflicher_status", 6, 4)}
      {renderCreditField("__person" + index + "__branche", 12, 4)}
      {renderCreditField("__person" + index + "__beruf", 6, 4)}
      {renderCreditField("__person" + index + "__beschaeftigt_seit", 6, 3)}
      {renderCreditField("__person" + index + "__pensionsantritt", 6, 3)}
      {renderCreditField("__person" + index + "__ausbildung", 12, 4)}
      {/*renderCreditField("__person" + index + "__dienstverhaeltnis_befristet", 6, 4)}
      {renderCreditField("__person" + index + "__dienstverhaeltnis_befristet_ja_art_der_beschaeftigung", 6, 4)*/}

      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__arbeitgeber_name", 12, 6)}
      {renderCreditField("__person" + index + "__arbeitgeber_plz", 4, 2)}
      {renderCreditField("__person" + index + "__arbeitgeber_ort", 8, 4)}
      {renderCreditField("__person" + index + "__arbeitgeber_strasse", 8, 4)}
      {renderCreditField("__person" + index + "__arbeitgeber_hausnummer", 4, 2)}

      <Fab
        variant="extended"
        size="small"
        className={classes.fab}
        color="secondary"
        onClick={() => {
          if (getPercentProgress() < 70) {
            savePortalFields(false);
          } else {
            pageContext.setConfirmDialog({
              open: true,
              title: "Alles fertig eingegeben?",
              message:
                "Möchten Sie Ihre Eingaben zurück an den Berater senden?",
              handleYes: () => {
                savePortalFields(true);
                pageContext.setConfirmDialog({
                  open: false,
                });
              },
              captionYes: "Ja, alles erledigt",
              handleNo: () => {
                savePortalFields(false);
                pageContext.setConfirmDialog({
                  open: false,
                });
              },
              captionNo: "Noch nicht, nur zwischenspeichern"
            });
          }
        }}
      >
        <CheckIcon className={classes.fabIcon} />
        Änderungen speichern
      </Fab>
    </>
  );
}
